import { ServiceAlertApiClient } from '@/libs/ServiceAlertApiClient';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as Common from '@/libs/Common';
import { useClientStore } from '@/stores/modules/clientInfo';

/**
 * @todo 登入檢查(for 9分鐘逾時提醒第10分鐘後登出)
 * @param refreshResult 是否強制刷新結果
 * @param handleError 是否自動處理錯誤
 * @returns 是否登入
 */
const ServiceAlertLoginCheck = async (handleError: boolean = true): Promise<boolean> => {
    Common.ConsoleLog('[ServiceAlert.LoginCheck] Api Start');

    const url = RouteUrlList.API_CheckIfLogin.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.false,
            getServiceAlert: ApiClient.paramTypeEnum.false
        }
    };

    const res: AxiosResponse<GeneralResp> = await ServiceAlertApiClient.post(url, {}, config);
    Common.ConsoleLog('[ServiceAlert.LoginCheck] Api isLogin call Api res :' + res.data.status);
    return res.data.status;
};
export default ServiceAlertLoginCheck;
